import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
import About from "./About";
import Services from "./Services";
import Education from "./Education";
import Work from "./MyWork";
import Contact from "./ContactForm";
import Footer from "./Footer";
import Navbar from "../Navbar";

function Home() {
  return (
    <>
      <HeroSection />
      <About />
      <Services />
      <Education />
      <Work />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;
